import React from 'react';
import styles from './ReportMetricsSection.module.css';

const BASIC_METRICS = [
    { key: 'total_protests',    label: 'إجمالي الاحتجاجات' },
    { key: 'total_participants', label: 'إجمالي المشاركين' },
    { key: 'avg_participants',  label: 'متوسط المشاركين' },
];

const CHART_METRICS = [
    { key: 'top_governorates',          label: 'أعلى المحافظات نشاطاً',    types: ['bar', 'pie', 'table'] },
    { key: 'political_orientation',     label: 'التوجهات السياسية',         types: ['pie', 'bar', 'table'] },
    { key: 'verified_ratio',            label: 'نسبة الاحتجاجات المرصودة', types: ['pie', 'bar', 'table'] },
    { key: 'protest_type_distribution', label: 'توزيع أنواع الاحتجاجات',   types: ['bar', 'pie', 'table'] },
    { key: 'tag_cloud',                 label: 'سحابة الكلمات',             types: ['cloud', 'table'] },
];

const TYPE_LABELS = {
    bar: '▦ عمودي',
    pie: '◔ دائري',
    cloud: '☁ سحابة',
    table: '≡ جدول',
};

export default function ReportMetricsSection({
    selectedMetrics,
    chartTypes,
    onMetricsChange,
    onChartTypesChange,
    onNext,
    onBack,
    loading,
}) {
    const toggle = (key) =>
        onMetricsChange({ ...selectedMetrics, [key]: !selectedMetrics[key] });

    const setChartType = (key, type) =>
        onChartTypesChange({ ...chartTypes, [key]: type });

    return (
        <div className={styles.section}>
            <h2 className={styles.title}>المؤشرات والأشكال البيانية</h2>
            <p className={styles.desc}>اختر المؤشرات وحدد نوع الرسم البياني لكل مؤشر</p>

            <div className={styles.block}>
                <h3 className={styles.blockTitle}>الإحصائيات الأساسية</h3>
                {BASIC_METRICS.map(({ key, label }) => (
                    <label key={key} className={styles.metricItem}>
                        <input
                            type="checkbox"
                            checked={selectedMetrics[key] ?? false}
                            onChange={() => toggle(key)}
                        />
                        <span>{label}</span>
                    </label>
                ))}
            </div>

            <div className={styles.block}>
                <h3 className={styles.blockTitle}>الرسوم البيانية</h3>
                {CHART_METRICS.map(({ key, label, types }) => (
                    <div key={key} className={styles.chartItem}>
                        <label className={styles.metricItem}>
                            <input
                                type="checkbox"
                                checked={selectedMetrics[key] ?? false}
                                onChange={() => toggle(key)}
                            />
                            <span>{label}</span>
                        </label>
                        {selectedMetrics[key] && (
                            <div className={styles.typeRow}>
                                {types.map((type) => (
                                    <button
                                        key={type}
                                        className={`${styles.typeBtn} ${chartTypes[key] === type ? styles.active : ''}`}
                                        onClick={() => setChartType(key, type)}
                                    >
                                        {TYPE_LABELS[type]}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className={styles.actions}>
                <button className={styles.backBtn} onClick={onBack}>← السابق</button>
                <button className={styles.nextBtn} onClick={onNext} disabled={loading}>
                    {loading ? 'جاري التحميل...' : 'عرض المعاينة ←'}
                </button>
            </div>
        </div>
    );
}
